<template>

  <div style="width: 300px; height: 300px; margin-bottom: 20px" ref="spColumn"></div>
</template>

<script>


export default {

  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    graph_data: {
      type: Object,
      required: true,
    },
    reload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ["get-client-stat"],
  watch: {
    timestamp() {
      if(this.reload){
        this.createGraph();
      }

      // if (this.action === "reload") {
      //   this.createGraph();
      // } else {
      //   if (this.evt == null) {
      //     this.evt = new CustomEvent(this.event_name);
      //   }
      //   this.$refs.date_chart.dispatchEvent(this.evt);
      // }
    },
  },
  data() {
    return {
      timeout: 0,
    };
  },
  methods: {
    tauxConseilChange(e) {
      clearTimeout(this.timeout);

      console.log(this.params.taux_conseil);
      this.timeout = setTimeout(() => {
        this.params.taux_conseil = Number.isInteger(parseInt(e.target.value))
          ? parseInt(e.target.value)
          : 1;

        this.$emit("get-client-stat");
      }, 500);
    },
    tauxAssureurChange(e) {
      this.params.taux_assureur = Number.isInteger(parseInt(e.target.value))
        ? parseInt(e.target.value)
        : 1;
      this.$emit("get-client-stat");
    },
    changeClick(click) {
      this.params.click = click;
      this.$emit("get-client-stat");
    },
    createGraph() {
      am4core.useTheme(am4themes_animated);
      am4core.options.commercialLicense = true;
      am4core.options.autoDispose = true;

      // var chart = am4core.create('uuid', am4charts.XYChart);

      var chart = am4core.create(
        this.$refs.spColumn,
        am4charts.XYChart
      );

      chart.data = [];

      this.graph_data.map((t) => {
        chart.data.push({
          label: t.label,
          value: t.rapport_sp,
          color: chart.colors.next(),
        });
      });

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "label";
      categoryAxis.renderer.grid.template.disabled = true;
    //   categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.inside = true;
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      categoryAxis.renderer.labels.template.fontSize = 14;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.strokeDasharray = "4,4";
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.labels.template.disabled = true;
      valueAxis.min = 0;
      valueAxis.extraMax = 0.2;

      // Remove padding
      chart.paddingBottom = 0;

      // Create series
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "label";
      series.columns.template.propertyFields.fill = "color";
      series.columns.template.propertyFields.stroke = "color";
      series.columns.template.column.cornerRadiusTopLeft = 30;
      series.columns.template.column.cornerRadiusTopRight = 30;
      series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/b]";

      var labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.horizontalCenter = "center";
      labelBullet.label.dx = -16;
      labelBullet.label.dy = -10;
      labelBullet.label.text = "[bold]{valueY}[/b]";
    },
  },
  mounted() {
    this.createGraph();
  },
};
</script>